import { Box, Typography } from '@mui/material';
import React from 'react';

interface StatWidgetProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  size?: 'small' | 'medium';
}

const StatWidget: React.FC<StatWidgetProps> = ({ icon, label, value, size = 'medium' }) => {
  const valueStyle = {
    fontSize: size === 'small' ? '11px' : 'inherit',
    lineHeight: size === 'small' ? '13px' : 'inherit',
  };
  const labelStyle = {
    fontSize: size === 'small' ? '10px !important' : 'inherit',
  };
  return (
    <Box>
      {icon}
      <Typography variant="h6" fontWeight="bold" sx={valueStyle}>
        {value}
      </Typography>
      <Typography color="text.secondary" sx={labelStyle}>
        {label}
      </Typography>
    </Box>
  );
};

export default StatWidget;
